import Logo from 'assets/img/Logo.svg';
import './Popup.css';

const Popup: React.FC<React.ReactNode> = ({ children }) => {
  return (
    <div className="popup">
      <div className="popup-content">
        <div className="logo">
          <img src={Logo} alt="ELSA" />
        </div>
        <div className="popup-body">{children}</div>
      </div>
    </div>
  );
};

export default Popup;
